import React from "react";

export const TotalNumberSmallBox = ({
  mainBoxOne,
  displayBox,
  walkinValue,
  waitlistValue,
  reservationValue,
  colorBoxOne,
  colorBoxTwo,
  colorBoxThree,
  headingText,
  valueText,
}) => {
  return (
    <React.Fragment>
      <div className={mainBoxOne}>
        <div>
          <div className={displayBox}>
            <div className={colorBoxOne}></div>
            <h5 className={headingText}>Walk-in</h5>
          </div>
          <div className="col-12 pl-1">
            <h3 className={valueText}>
              {walkinValue} <span className="small-text">pax</span>
            </h3>
          </div>
        </div>
        <div>
          <div className={displayBox}>
            <div className={colorBoxTwo}></div>
            <h5 className={headingText}>Waitlist</h5>
          </div>
          <div className="col-12 pl-1">
            <h3 className={valueText}>
              {waitlistValue} <span className="small-text">pax</span>
            </h3>
          </div>
        </div>
        <div>
          <div className={displayBox}>
            <div className={colorBoxThree}></div>
            <h5 className={headingText}>Reservation</h5>
          </div>
          <div className="col-12 pl-1">
            <h3 className={valueText}>
              {reservationValue} <span className="small-text">pax</span>
            </h3>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export const TotalNumberSmallDateRange = ({
  leftSmallText,
  middleSmallText,
  rightSmallText,
  middleBottomValue,
  rightBottomValue,
}) => {
  return (
    <React.Fragment>
      <div className="col-12 main-total-number-date-range">
        <div className="row">
          <div className="col">
            <h5>{leftSmallText}</h5>
          </div>
          <div className="col">
            <div className="d-flex align-items-center">
              <div className="color-box-one color-orange "></div>
              <h5>{middleSmallText}</h5>
            </div>
            <div className="col-12 pl-1">
              <h3>
                {middleBottomValue} <span className="small-text">pax</span>
              </h3>
            </div>
          </div>
          <div className="col">
            <div className="d-flex align-items-center">
              <div className="color-box-one color-red"></div>
              <h5>{rightSmallText}</h5>
            </div>
            <div className="col-12 pl-1">
              <h3>
                {rightBottomValue} <span className="small-text">pax</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
